import './auto-added-reconciliation-report-dropdown'
import './automatically-followed-banner'
import './checks-not-visible-in-workflow-warning'
import './export-file-instance-modal-content'
import './pulse-pending-changes'
import './pulse-workflow-progress'
import './workflow-completion'
import './workflow-review'
import './workflow-review-sidepane'
import './workflow-review-subnav-secondary-left'
import './workflow-review-subnav-secondary-right'
import './workflow-status'
import './working-screen'
import './workflow-review-status'
import './workflow-stacking-headers'
import './follow-company-toggle'
import setupShowSyncErrors from './setup-show-sync-errors'
import setupPrepareTab from './setup-prepare-tab'
import './trigger'

setupShowSyncErrors()
setupPrepareTab()
